import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Composant pour protéger le site
function ProtectionLayer() {
  useEffect(() => {
    // Désactiver le clic droit
    const handleContextMenu = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Désactiver les raccourcis clavier (Ctrl+U, Ctrl+S, F12, etc.)
    const handleKeyDown = (e) => {
      // F12 (DevTools)
      if (e.keyCode === 123) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+U (Afficher le code source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+S (Sauvegarder)
      if (e.ctrlKey && e.keyCode === 83) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+Shift+C (Inspecteur)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+A (Sélectionner tout)
      if (e.ctrlKey && e.keyCode === 65) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+C (Copier)
      if (e.ctrlKey && e.keyCode === 67) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+X (Couper)
      if (e.ctrlKey && e.keyCode === 88) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+P (Imprimer)
      if (e.ctrlKey && e.keyCode === 80) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      // Ctrl+V (Coller) - optionnel, peut être gardé pour les formulaires
      // if (e.ctrlKey && e.keyCode === 86) {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   return false;
      // }
    };

    // Désactiver la sélection de texte avec la souris
    const handleSelectStart = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Désactiver le glisser-déposer (drag and drop)
    const handleDragStart = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Désactiver la copie
    const handleCopy = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Désactiver le couper (cut)
    const handleCut = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    // Ajouter les écouteurs d'événements
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCut);

    // Nettoyer les écouteurs lors du démontage
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCut);
    };
  }, []);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ProtectionLayer />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
